






import { controls } from "../../controls";


const intstopinformation = {
  label: "Int Stop",
  pageLabel: "Int Stop",
  starting: true,
  url: "intstopinformation",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [

    ...controls.displayText({ star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ isRequired: true, width: "col-sm-2" }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-2", label: "Search" }),
    ...controls.text({ placeHolder: "Search", name: "search", width: "col-sm-4" }),
    ...controls.displayText({ star: true, label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ isRequired: true, width: "col-sm-4" }),
    ...controls.showData({ data: "product_code_display", name: "product_code_display", width: "col-sm-4" }),
    ...controls.displayText({ width: "col-sm-2" }),
    ...controls.displayText({ label: "Customer Type", width: "col-sm-2" }),
    ...controls.select({
      width: "col-sm-4", options: [
        {
          label: "individual",
          value: "individual"
        },
        {
          label: "internal",
          value: "internal"
        },
        {
          label: "Other",
          value: "other"
        }
      ], name: "customer_type"
    }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ label: "Customer Number", width: "col-sm-2" }),
    ...controls.customerNumber({ width: "col-sm-4" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ label: "Account No.", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Enter Account No", name: "acct_number", width: "col-sm-4", defaultValue: "account_number" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ label: "Name", width: "col-sm-2" }),
    ...controls.text({ placeHolder: "Name", name: "name", width: "col-sm-4" }),
    ...controls.displayText({ width: "col-sm-6" }),
    ...controls.displayText({ label: "No of Records", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "No of Records", name: "per_page", width: "col-sm-4" }),


  ]
}

export default intstopinformation;